import React, { useState, useEffect, useCallback } from 'react';
import {
  Box, Card, CardContent, Grid, Typography, Button, TextField, Table, TableBody, TableCell, TableHead, TableRow,
  ToggleButtonGroup, ToggleButton, Alert, Chip, Dialog, DialogTitle, DialogContent, Tabs, Tab,
} from '@mui/material';
import { Refresh, Save } from '@mui/icons-material';
import useMediaQuery from '@mui/material/useMediaQuery';
import axios from 'axios';

// 🪱 Wiggle Wars — вся статистика игры (владелец 19.10: «как Sugar Strike: кто какие бои создавал, кто что делал, все
// логи, касса, умный балансировщик, RTP — чтобы я всё видел»). Сервер — wiggle-backend (/wiggle/api/admin/*).
// Джекпота у Wiggle нет: ставки в него не идут.
const API = 'https://slots.moonraid.online/wiggle/api/admin';
const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('adminToken')}` });
const fmt = (x) => (Math.round((Number(x) || 0) * 100) / 100).toLocaleString('ru-RU');
const pct = (x) => (x === null || x === undefined ? '—' : `${(Number(x) * 100).toFixed(1)}%`);
const rtpColor = (x) => (x === null || x === undefined ? undefined : x > 1 ? '#ff6b6b' : x > 0.96 ? '#ffb347' : '#7be495');

const FIELDS = [
  ['stakeMax', 'Потолок ставки против ботов, SPERM', 'Максимум 500.'],
  ['target', 'Цель отдачи (RTP)', '0.94 = 94%: столько касса стремится вернуть со ставок.'],
  ['skill_easy', 'Меткость «Новичок» (база)', '0 — мажет, 1 — снайпер. Регулятор сдвигает от базы.'],
  ['skill_mid', 'Меткость «Боец» (база)', ''],
  ['skill_hard', 'Меткость «Ветеран» (база)', ''],
  ['kPersonal', 'Личный контур: сила', 'Чем больше — тем сильнее бот меняется под выигрыши игрока.'],
  ['maxPersonal', 'Личный контур: предел ослабления', 'Насколько бот может стать слабее, если игрок проигрывает.'],
  ['maxPersonalUp', 'Личный контур: предел усиления', 'Насколько бот может стать точнее, если игрок забирает больше цели.'],
  ['cushion', 'Личный контур: подушка, SPERM', 'Пока оборот игрока меньше подушки, расчёт почти не двигается.'],
  ['kGlobal', 'Общий контур: сила', 'По факту отдачи уровня за последние матчи.'],
  ['maxGlobal', 'Общий контур: предел сдвига', ''],
  ['window', 'Общий контур: окно, матчей', ''],
  ['min', 'Меткость не ниже', ''],
  ['max', 'Меткость не выше', 'Выше 1 — бот почти без промаха (запас против сильных игроков).'],
  ['tankodrom', 'Карта «Танкодром» включена', '1 — бои идут и на Танкодроме, 0 — только Полигон (сразу, без перезапуска).'],
  ['ai', 'ИИ-командир ботов', '1 — каждый ход бот спрашивает нейросеть (DeepSeek, запасной MiniMax), какой из своих вариантов взять; 0 — боты как раньше. Для новых боёв.'],
];

const MODE = { duel: 'Дуэль 1×1', bots: 'Против ботов', team: '2 на 2' };
const LEVEL = { easy: 'Новичок', mid: 'Боец', hard: 'Ветеран' };
const CALL_STATUS = { open: 'ждёт соперника', agreed: 'договорились', propose: 'спорят о времени', room: 'в комнате', done: 'сыгран', expired: 'не состоялся', cancelled: 'отменён' };
/** Действия журнала словами. */
const EV = {
  table_create: 'создал бой', table_join: 'зашёл в бой', table_leave: 'вышел из боя до начала', table_close: 'бой закрыт', ready: '✓ готов', unready: 'не готов',
  match_start: 'бой начался', match_end: 'бой окончен', surrender: 'сдался / вышел', offline: 'вылетел из сети', online: 'вернулся в сеть',
  call_create: 'бросил вызов', call_push: 'пуш о вызове', call_accept: 'принял вызов', call_propose: 'предложил время', call_agree: 'согласился',
  call_cancel: 'отменил вызов', call_decline: 'отказался от вызова', call_expired: 'вызов протух', call_noshow: 'не явились', callme_on: 'включил «звать на бои»', callme_off: 'выключил «звать на бои»',
};
const when = (t) => (t ? new Date(t).toLocaleString('ru-RU', { timeZone: 'Europe/Moscow', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '—');
const whenS = (t) => (t ? new Date(t).toLocaleString('ru-RU', { timeZone: 'Europe/Moscow', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }) : '—');
/** Итог боя словами: кто победил (сторона или люди/боты), почему. */
function result(m) {
  const why = { win: '', draw: 'ничья', left: 'вылет', surrender: 'сдался', quit: 'покинул', restart: 'перезапуск', hp: 'по здоровью' }[m.end_reason] || m.end_reason || '';
  if (m.status === 'live') return 'идёт';
  if (m.status === 'refunded') return 'возврат ставок';
  if (m.status === 'cancelled') return 'отменён до начала';
  if (m.winner === -1 || m.winner === null) return why || 'ничья';
  const names = m.who || [];
  let w;
  if (m.mode === 'bots') w = m.winner === 0 ? 'люди' : 'боты';
  else if (m.mode === 'duel') w = names[m.winner]?.name || `сторона ${m.winner}`;
  else w = names.filter((_, i) => i % 2 === m.winner).map((x) => x.name).join(' и ') || `сторона ${m.winner}`;
  return `победа: ${w}${why ? ` (${why})` : ''}`;
}
/** Подробности события коротко. */
function evData(e) {
  const d = e.data || {};
  const parts = [];
  if (d.kind) parts.push(MODE[d.kind] || d.kind);
  if (d.mode) parts.push(MODE[d.mode] || d.mode);
  if (d.level) parts.push(LEVEL[d.level] || d.level);
  if (d.stake !== undefined) parts.push(Number(d.stake) ? `ставка ${fmt(d.stake)}` : 'на интерес');
  if (d.reason) parts.push(`итог: ${d.reason}${d.winner !== undefined ? `, победитель ${d.winner}` : ''}`);
  if (d.prize) parts.push(`выплата ${fmt(d.prize)}`);
  if (d.each) parts.push(`каждому ${fmt(d.each)}`);
  if (d.rake) parts.push(`комиссия ${fmt(d.rake)}`);
  if (d.skill !== undefined) parts.push(`меткость ${d.skill}`);
  if (d.minutes) parts.push(`${d.minutes} мин`);
  if (d.players) parts.push(d.players.join(', '));
  if (d.seats) parts.push(d.seats.join(', '));
  if (d.host) parts.push(`хозяин ${d.host}`);
  if (d.author) parts.push(`автор ${d.author}`);
  if (d.at) parts.push(`на ${when(d.at)}`);
  if (d.to !== undefined) parts.push(`получили ${d.to}`);
  if (d.why) parts.push(d.why);
  if (d.solo) parts.push('один');
  if (d.auto) parts.push('сам по «Готов»');
  return parts.join(' · ');
}

/** Кто: @ник крупно, имя и id мелко (владелец 19.10: «где юзернеймы конкретно игроков?»). */
const Who = ({ username, name, id, onClick }) => (
  <Box component="span" onClick={onClick} sx={{ cursor: onClick ? 'pointer' : undefined, display: 'inline-block', mr: 1 }}>
    <b style={{ color: '#e6ecff' }}>{username ? `@${username}` : name || `id ${id}`}</b>
    {(username && name) || id ? <small style={{ color: '#7f8db0', marginLeft: 4 }}>{username && name ? name : ''}{id ? ` · id ${id}` : ''}</small> : null}
  </Box>
);

/** Таблица на компьютере, карточки на телефоне (владелец 19.10: «вёрстка тупая» — колонки переносились по буквам).
 *  cols: [{ h, v(row), card? }], title(row) — шапка карточки. */
function DataView({ cols, rows, title, onRow, empty, mobile, maxHeight = 620 }) {
  if (mobile) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 3 }}>
        {rows.map((r, i) => (
          <Card key={i} onClick={onRow ? () => onRow(r) : undefined}
            sx={{ bgcolor: '#121a2e', border: '1px solid rgba(255,255,255,0.07)', cursor: onRow ? 'pointer' : undefined }}>
            <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
              {title && <Box sx={{ mb: 0.75, fontWeight: 800, fontSize: 15 }}>{title(r)}</Box>}
              <Box sx={{ display: 'grid', gridTemplateColumns: 'auto 1fr', columnGap: 1.5, rowGap: 0.5, fontSize: 13.5 }}>
                {cols.filter((c) => c.card !== false).map((c, k) => (
                  <React.Fragment key={k}>
                    <Box sx={{ color: '#8fa1c4', whiteSpace: 'nowrap' }}>{c.h}</Box>
                    <Box sx={{ minWidth: 0, wordBreak: 'break-word' }}>{c.v(r)}</Box>
                  </React.Fragment>
                ))}
              </Box>
            </CardContent>
          </Card>
        ))}
        {!rows.length && <Typography variant="body2" sx={{ color: '#8fa1c4' }}>{empty}</Typography>}
      </Box>
    );
  }
  return (
    <Box sx={{ overflowX: 'auto', mb: 3, maxHeight, overflowY: 'auto' }}>
      <Table size="small" stickyHeader>
        <TableHead><TableRow>{cols.map((c, k) => <TableCell key={k} sx={{ whiteSpace: 'nowrap' }}>{c.h}</TableCell>)}</TableRow></TableHead>
        <TableBody>
          {rows.map((r, i) => (
            <TableRow key={i} hover onClick={onRow ? () => onRow(r) : undefined} sx={{ cursor: onRow ? 'pointer' : undefined }}>
              {cols.map((c, k) => <TableCell key={k}>{c.v(r)}</TableCell>)}
            </TableRow>
          ))}
          {!rows.length && <TableRow><TableCell colSpan={cols.length}>{empty}</TableCell></TableRow>}
        </TableBody>
      </Table>
    </Box>
  );
}

const Stat = ({ label, value, color, hint }) => (
  <Card sx={{ bgcolor: '#0e1424', border: '1px solid rgba(255,255,255,0.06)', height: '100%' }}>
    <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 } }}>
      <Typography variant="caption" sx={{ color: '#8fa1c4' }}>{label}</Typography>
      <Typography variant="h6" sx={{ fontWeight: 800, color }}>{value}</Typography>
      {hint && <Typography variant="caption" sx={{ color: '#5b6b8c', display: 'block' }}>{hint}</Typography>}
    </CardContent>
  </Card>
);

/** «Сейчас»: кто в игре и где, идущие бои (стороны, здоровье, чей ход, «Смотреть»), созданные бои, которые ждут игроков. Раз в 3 с.
 *  Владелец 20.10: слова «стол» в Wiggle нет — это покер; здесь только «бой». */
function NowTab({ now, mobile, onWatch, onPlayer }) {
  if (!now) return <Typography sx={{ color: '#8fa1c4' }}>Загрузка…</Typography>;
  const nick = (uid, name) => `${name}${now.users?.[uid]?.username ? ` @${now.users[uid].username}` : ''}`;
  const where = (o) => (o.match ? `в бою №${o.match}` : o.table ? `ждёт начала боя №${o.table}` : 'в меню / лобби');
  const money = (stake) => (Number(stake) ? `${fmt(stake)} SPERM` : 'на интерес');
  const mmss = (k) => { const sec = Math.floor(k / 60); return `${Math.floor(sec / 60)}:${String(sec % 60).padStart(2, '0')}`; };
  const SIDE = ['#ff4a3d', '#3b8bff'];
  const card = { bgcolor: '#0e1424', border: '1px solid rgba(255,255,255,0.06)', mb: 2 };
  return (
    <Box>
      <Card sx={card}><CardContent>
        <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>🟢 Онлайн сейчас: {now.online.length}</Typography>
        {!now.online.length && <Typography variant="body2" sx={{ color: '#8fa1c4' }}>В игре никого.</Typography>}
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {now.online.map((o) => (
            <Chip key={o.uid} clickable onClick={() => onPlayer(o.uid)} label={`${nick(o.uid, o.name)} · ${where(o)}`}
              sx={{ bgcolor: o.match ? 'rgba(255,74,61,.18)' : o.table ? 'rgba(255,179,71,.18)' : '#ffffff10' }} />
          ))}
        </Box>
      </CardContent></Card>

      <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>⚔️ Идут бои: {now.fights.length}</Typography>
      {!now.fights.length && <Typography variant="body2" sx={{ color: '#8fa1c4', mb: 2 }}>Сейчас боёв нет.</Typography>}
      {now.fights.map((f) => (
        <Card key={f.id} sx={card}><CardContent>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', mb: 1 }}>
            <Typography sx={{ fontWeight: 700 }}>№{f.id}</Typography>
            <Chip size="small" label={`${MODE[f.mode] || f.mode}${f.level && f.mode === 'bots' ? ` · ${LEVEL[f.level] || f.level}` : ''}`} />
            <Chip size="small" label={money(f.stake)} />
            {f.people.some((p) => p.ticket) && <Chip size="small" color="warning" label="🎟 билетом (промокод)" />}
            <Chip size="small" label={f.map === 'tankodrom' ? 'Танкодром' : 'Полигон'} />
            <Chip size="small" label={`ход ${f.turn} · ${mmss(f.tick)}`} />
            <Box sx={{ flex: 1 }} />
            <Button variant="contained" color="error" size="small" onClick={() => onWatch(f.id)}>👁 Смотреть</Button>
          </Box>
          <Grid container spacing={1}>
            {f.teams.map((t, i) => (
              <Grid item xs={12} sm={6} key={i}>
                <Box sx={{ p: 1, borderLeft: `3px solid ${SIDE[i]}`, bgcolor: f.turnTeam === i ? 'rgba(255,255,255,.05)' : 'transparent', borderRadius: 1 }}>
                  <Typography variant="body2" sx={{ fontWeight: 700 }}>
                    {t.bot ? '🤖 ' : ''}{t.name}{f.turnTeam === i && f.phase !== 'over' ? ' · ходит' : ''}
                  </Typography>
                  <Typography variant="caption" sx={{ color: '#8fa1c4', display: 'block' }}>❤️ {t.hp} · живых {t.alive} из {t.of}</Typography>
                  {f.people.filter((p) => p.side === i).map((p) => (
                    <Typography key={p.uid} variant="caption" sx={{ display: 'block', cursor: 'pointer' }} onClick={() => onPlayer(p.uid)}>
                      {p.on ? '🟢' : '⚪'} {nick(p.uid, p.name)}{p.ticket ? ' · 🎟' : ''}{p.quit ? ' · покинул' : ''}{!p.on ? ' · не в сети' : ''}
                    </Typography>
                  ))}
                </Box>
              </Grid>
            ))}
          </Grid>
        </CardContent></Card>
      ))}

      <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>⏳ Ждут игроков: {now.rooms.length}</Typography>
      {!now.rooms.length && <Typography variant="body2" sx={{ color: '#8fa1c4' }}>Созданных боёв, которые ждут игроков, нет.</Typography>}
      {now.rooms.map((r) => (
        <Card key={r.id} sx={card}><CardContent sx={{ py: mobile ? 1 : 1.5 }}>
          <Typography variant="body2" sx={{ fontWeight: 700 }}>
            №{r.id} · {MODE[r.kind] || r.kind}{r.kind === 'bots' ? ` · ${LEVEL[r.level] || r.level}` : ''} · {money(r.stake)}{r.priv ? ' · 🔒 по ссылке' : ''}{r.call ? ' · по вызову' : ''}
          </Typography>
          {r.seats.map((x) => (
            <Typography key={x.uid} variant="caption" sx={{ display: 'block' }}>
              {x.on ? '🟢' : '⚪'} {nick(x.uid, x.name)}{x.ready ? ' · ✓ готов' : ''}{x.ticket ? ' · 🎟' : ''}
            </Typography>
          ))}
        </CardContent></Card>
      ))}
    </Box>
  );
}

export default function WiggleAdmin() {
  const mobile = useMediaQuery('(max-width:760px)');
  // вкладка «Сейчас» (20.10, владелец: «зашёл — вижу, кто онлайн и какие бои идут, нажал — смотрю вживую») — первой
  const [tab, setTab] = useState('now');
  const [now, setNow] = useState(null);
  const [data, setData] = useState(null);
  const [sum, setSum] = useState(null);
  const [days, setDays] = useState(7);
  const [reg, setReg] = useState(null);
  const [matches, setMatches] = useState([]);
  const [mode, setMode] = useState('');
  const [uid, setUid] = useState('');
  const [players, setPlayers] = useState([]);
  const [pdays, setPdays] = useState(30);
  const [calls, setCalls] = useState([]);
  const [events, setEvents] = useState([]);
  const [evq, setEvq] = useState({ q: '', ev: '' });
  const [chat, setChat] = useState(null);
  const [form, setForm] = useState({});
  const [msg, setMsg] = useState(null);

  const get = (path, params) => axios.get(`${API}/${path}`, { params, headers: authHeaders() }).then((r) => r.data);
  const load = useCallback(async () => {
    try {
      const st = await get('stats');
      if (st?.success) { setData(st); setForm((f) => (Object.keys(f).length ? f : st.tune)); }
      if (tab === 'now') { const n = await get('now'); if (n?.success) setNow(n); }
      if (tab === 0) { const s = await get('summary', { days }); if (s?.success) setSum(s); }
      if (tab === 1) { const r = await get('regulator'); if (r?.success) setReg(r); }
      if (tab === 2) { const m = await get('matches', { limit: 150, mode: mode || undefined, uid: uid || undefined }); if (m?.success) setMatches(m.matches); }
      if (tab === 3) { const p = await get('players', { days: pdays }); if (p?.success) setPlayers(p.players); }
      if (tab === 4) { const c = await get('calls', { limit: 150 }); if (c?.success) setCalls(c.calls); }
      if (tab === 5) { const e = await get('events', { limit: 400, q: evq.q || undefined, ev: evq.ev || undefined, uid: uid || undefined }); if (e?.success) setEvents(e.events); }
    } catch (e) { setMsg({ type: 'error', text: e.response?.data?.error || 'Сервер Wiggle не ответил' }); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab, days, mode, uid, pdays, evq]);
  useEffect(() => { load(); const t = setInterval(load, 30000); return () => clearInterval(t); }, [load]);
  // «Сейчас» — живая картинка: раз в 3 с
  useEffect(() => {
    if (tab !== 'now') return undefined;
    const t = setInterval(async () => { try { const n = await get('now'); if (n?.success) setNow(n); } catch (e) { /* следующий раз */ } }, 3000);
    return () => clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab]);

  const openChat = async (m) => {
    try {
      const r = await get('chat', { match: m.id });
      if (r?.success) setChat({ match: m, rows: r.chat, models: r.models });
    } catch (e) { setMsg({ type: 'error', text: 'Не загрузился чат' }); }
  };
  /** Запись боя (19.10): сервер даёт подписанную ссылку на просмотр в игре (живёт 2 часа) — открываем в новой вкладке.
   *  Вкладку открываем сразу по клику (иначе браузер заблокирует всплывающее окно), адрес подставляем после ответа. */
  const openReplay = async (m) => {
    const w = window.open('', '_blank');
    try {
      const r = await get('replay-link', { id: m.id });
      if (r?.url && w) w.location.href = r.url; else { w?.close(); setMsg({ type: 'error', text: 'Запись не открылась' }); }
    } catch (e) { w?.close(); setMsg({ type: 'error', text: 'Запись не открылась' }); }
  };
  /** Живой просмотр идущего боя: подписанная ссылка в игру (?watch=), как у записи. */
  const openWatch = async (id) => {
    const w = window.open('', '_blank');
    try {
      const r = await get('watch-link', { id });
      if (r?.url && w) w.location.href = r.url; else { w?.close(); setMsg({ type: 'error', text: 'Просмотр не открылся' }); }
    } catch (e) { w?.close(); setMsg({ type: 'error', text: 'Просмотр не открылся' }); }
  };
  /** Всё про игрока: бои и журнал по нему. */
  const byPlayer = (id) => { setUid(String(id)); setTab(2); };
  const save = async () => {
    try {
      const body = Object.fromEntries(FIELDS.map(([k]) => [k, Number(form[k])]));
      const r = await axios.post(`${API}/tune`, body, { headers: authHeaders() });
      if (r.data?.success) { setForm(r.data.tune); setMsg({ type: 'success', text: 'Сохранено — действует со следующего боя' }); }
    } catch (e) { setMsg({ type: 'error', text: e.response?.data?.error || 'Не сохранилось' }); }
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1, flexWrap: 'wrap' }}>
        <Typography variant="h6">🪱 Wiggle Wars</Typography>
        {data && <Chip size="small" clickable onClick={() => setTab('now')} color={data.live.matches ? 'error' : 'default'}
          label={`🔴 идёт боёв: ${data.live.matches} · ждут игроков: ${data.live.rooms} · онлайн: ${data.live.online}`} />}
        <Chip size="small" label="в джекпоте не участвует" sx={{ bgcolor: '#ffffff10' }} />
        <Button size="small" startIcon={<Refresh />} onClick={load}>Обновить</Button>
      </Box>
      {msg && <Alert severity={msg.type} sx={{ mb: 2 }} onClose={() => setMsg(null)}>{msg.text}</Alert>}
      <Tabs value={tab} onChange={(e, v) => setTab(v)} variant="scrollable" scrollButtons="auto" sx={{ mb: 2 }}>
        <Tab value="now" label={`🔴 Сейчас${now ? ` · ${now.online.length}` : ''}`} />
        <Tab value={0} label="Сводка" /><Tab value={1} label="Умная касса" /><Tab value={2} label="Бои" /><Tab value={3} label="Игроки" />
        <Tab value={4} label="Вызовы" /><Tab value={5} label="Журнал" /><Tab value={6} label="Ручки" />
      </Tabs>

      {tab === 'now' && <NowTab now={now} mobile={mobile} onWatch={openWatch} onPlayer={byPlayer} />}

      {tab === 0 && (
        <Box>
          <ToggleButtonGroup size="small" exclusive value={days} onChange={(e, v) => v !== null && setDays(v)} sx={{ mb: 2, flexWrap: 'wrap' }}>
            <ToggleButton value={1}>Сутки</ToggleButton><ToggleButton value={7}>Неделя</ToggleButton><ToggleButton value={30}>Месяц</ToggleButton><ToggleButton value={0}>Всё время</ToggleButton>
          </ToggleButtonGroup>
          {sum && (
            <>
              <Grid container spacing={1.5} sx={{ mb: 2 }}>
                <Grid item xs={6} md={3}><Stat label="Доход дома, SPERM" value={fmt(sum.total.house)} color={sum.total.house >= 0 ? '#7be495' : '#ff6b6b'} hint="боты: оборот − выплаты; люди: комиссия 6%" /></Grid>
                <Grid item xs={6} md={3}><Stat label="RTP всей игры (факт)" value={pct(sum.total.rtp)} color={rtpColor(sum.total.rtp)} hint="1 − доход / оборот" /></Grid>
                <Grid item xs={6} md={3}><Stat label="Оборот, SPERM" value={fmt(sum.total.turnover)} hint="ставки боёв на деньги" /></Grid>
                <Grid item xs={6} md={3}><Stat label="Боёв / игроков" value={`${sum.total.n} / ${sum.people}`} /></Grid>
              </Grid>
              <DataView mobile={mobile} rows={sum.modes} empty="За период боёв нет"
                title={(r) => MODE[r.mode] || r.mode}
                cols={[
                  { h: 'Режим', v: (r) => MODE[r.mode] || r.mode, card: false },
                  { h: 'Боёв', v: (r) => `${r.n} (на деньги ${r.money_n}, на интерес ${r.free_n})` },
                  { h: 'Ничьих', v: (r) => r.draws },
                  { h: 'Оборот', v: (r) => fmt(r.turnover) },
                  { h: 'Выплачено', v: (r) => fmt(r.payout) },
                  { h: 'Комиссия', v: (r) => fmt(r.rake) },
                  { h: 'Доход дома', v: (r) => <b style={{ color: r.house >= 0 ? '#7be495' : '#ff6b6b' }}>{fmt(r.house)}</b> },
                  { h: 'RTP', v: (r) => <b style={{ color: rtpColor(r.rtp) }}>{pct(r.rtp)}</b> },
                  { h: 'Ср. ставка', v: (r) => (r.avg_stake ? fmt(r.avg_stake) : '—') },
                  { h: 'Ср. длина', v: (r) => (r.avg_min ? `${r.avg_min} мин` : '—') },
                ]} />
              <Typography variant="body2" sx={{ color: '#8fa1c4' }}>
                Вызовы за период: {sum.calls.length ? sum.calls.map((c) => `${CALL_STATUS[c.status] || c.status} — ${c.n}`).join(', ') : 'нет'}.
                {' '}В дуэлях и 2×2 дом не рискует: банк делят люди, дому — 6%. Риск кассы только в боях против ботов — его держит умная касса.
              </Typography>
            </>
          )}
        </Box>
      )}

      {tab === 1 && reg && (
        <Box>
          <Typography variant="body2" sx={{ color: '#8fa1c4', mb: 2 }}>
            Выплата за победу против ботов фиксирована (×1.3 / ×1.6 / ×2), касса двигает только меткость ботов, чтобы отдача держалась у цели {pct(reg.tune.target)}.
            Меткость боя = база уровня + общая поправка уровня + личная поправка игрока (в пределах {reg.tune.min}…{reg.tune.max}). Бои на интерес не считаются.
          </Typography>
          <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>Уровни — общий контур (последние {reg.tune.window} боёв на деньги)</Typography>
          <DataView mobile={mobile} rows={reg.levels} empty="—" title={(l) => `${l.name} ×${l.mult}`}
            cols={[
              { h: 'Уровень', v: (l) => `${l.name} ×${l.mult}`, card: false },
              { h: 'Боёв', v: (l) => l.n },
              { h: 'Побед людей', v: (l) => (l.n ? `${Math.round((l.wins / l.n) * 100)}%` : '—') },
              { h: 'Оборот', v: (l) => fmt(l.turnover) },
              { h: 'Выплачено', v: (l) => fmt(l.paid) },
              { h: 'RTP факт / цель', v: (l) => <span><b style={{ color: rtpColor(l.rtp) }}>{pct(l.rtp)}</b> / {pct(l.target)}</span> },
              { h: 'База меткости', v: (l) => l.base },
              { h: 'Общая поправка', v: (l) => <span style={{ color: l.global > 0 ? '#ffb347' : l.global < 0 ? '#7be495' : undefined }}>{l.global > 0 ? '+' : ''}{l.global.toFixed(3)}</span> },
              { h: 'Меткость в боях', v: (l) => l.avgSkill ?? '—' },
            ]} />
          <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>Игроки — личный контур</Typography>
          <Typography variant="caption" sx={{ color: '#8fa1c4', display: 'block', mb: 1 }}>
            «+» — бот для этого игрока точнее (он забирает больше цели), «−» — слабее. Подушка {fmt(reg.tune.cushion)} SPERM: пока оборот мал, поправка почти ноль.
          </Typography>
          <DataView mobile={mobile} rows={reg.players} empty="Боёв на деньги против ботов пока нет" onRow={(p) => byPlayer(p.uid)}
            title={(p) => <Who username={p.username} name={p.name} id={p.uid} />}
            cols={[
              { h: 'Игрок', v: (p) => <Who username={p.username} name={p.name} id={p.uid} />, card: false },
              { h: 'Уровень', v: (p) => LEVEL[p.level] },
              { h: 'Боёв / побед', v: (p) => `${p.n} / ${p.wins}` },
              { h: 'Поставил', v: (p) => fmt(p.turn) },
              { h: 'Получил', v: (p) => fmt(p.paid) },
              { h: 'RTP игрока', v: (p) => <b style={{ color: rtpColor(p.rtp) }}>{pct(p.rtp)}</b> },
              { h: 'Личная поправка', v: (p) => <span style={{ color: p.personal > 0 ? '#ffb347' : p.personal < 0 ? '#7be495' : undefined }}>{p.personal > 0 ? '+' : ''}{p.personal.toFixed(3)}</span> },
              { h: 'Меткость (ср.)', v: (p) => p.skill ?? '—' },
              { h: 'Последний бой', v: (p) => when(p.last_at) },
            ]} />
        </Box>
      )}

      {tab === 2 && (
        <Box>
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap', mb: 1 }}>
            <ToggleButtonGroup size="small" exclusive value={mode} onChange={(e, v) => setMode(v ?? '')} sx={{ flexWrap: 'wrap' }}>
              <ToggleButton value="">Все</ToggleButton><ToggleButton value="duel">Дуэли</ToggleButton><ToggleButton value="bots">Боты</ToggleButton><ToggleButton value="team">2 на 2</ToggleButton>
            </ToggleButtonGroup>
            <TextField size="small" label="id игрока" value={uid} onChange={(e) => setUid(e.target.value.replace(/\D/g, ''))} sx={{ width: 120 }} />
            {uid && <Button size="small" onClick={() => setUid('')}>Сбросить</Button>}
            {uid && <Button size="small" onClick={() => setTab(5)}>Журнал игрока</Button>}
          </Box>
          <DataView mobile={mobile} rows={matches} empty="Боёв нет"
            title={(m) => `№${m.id} · ${MODE[m.mode] || m.mode}${m.mode === 'bots' && m.level ? ` · ${LEVEL[m.level]} ×${Number(m.mult)}` : ''} · ${Number(m.stake) ? `${fmt(m.stake)} SPERM` : 'на интерес'}`}
            cols={[
              { h: '№', v: (m) => m.id, card: false },
              { h: 'Создан', v: (m) => when(m.created_at) },
              { h: 'Создал', v: (m) => <Who username={m.creator_username} name={m.creator_name} id={m.creator} onClick={(e) => { e.stopPropagation?.(); setUid(String(m.creator)); }} /> },
              { h: 'Режим', v: (m) => <span>{MODE[m.mode] || m.mode}{m.mode === 'bots' && m.level ? ` · ${LEVEL[m.level]} ×${Number(m.mult)}` : ''}</span>, card: false },
              { h: 'Игроки', v: (m) => (m.who || []).map((u) => <Who key={u.id} username={u.username} name={u.name} id={u.id} onClick={() => setUid(String(u.id))} />) },
              { h: 'Ставка', v: (m) => (Number(m.stake) ? fmt(m.stake) : 'интерес'), card: false },
              { h: 'Итог', v: (m) => result(m) },
              { h: 'Выплачено', v: (m) => fmt(m.payout) },
              { h: 'Комиссия', v: (m) => fmt(m.rake) },
              { h: 'Меткость ботов', v: (m) => (m.bot_skill != null ? Number(m.bot_skill) : '—') },
              { h: 'Длился', v: (m) => `${m.minutes} мин` },
              { h: 'Чат', v: (m) => (m.chat_n ? <Button size="small" onClick={() => openChat(m)}>{m.chat_n} сообщ.{m.bot_n ? ` (🤖${m.bot_n})` : ''}</Button> : '—') },
              // запись боя целиком; ⚠ — чёрный ящик заметил долгие паузы или отставание сервера (подробности — в записи)
              { h: 'Запись', v: (m) => (m.has_replay ? <Button size="small" variant="outlined" onClick={() => openReplay(m)}>▶ Смотреть{m.diag?.length ? ` · ⚠${m.diag.length}` : ''}</Button> : '—') },
            ]} />
        </Box>
      )}

      {tab === 3 && (
        <Box>
          <ToggleButtonGroup size="small" exclusive value={pdays} onChange={(e, v) => v && setPdays(v)} sx={{ mb: 1, flexWrap: 'wrap' }}>
            <ToggleButton value={1}>Сутки</ToggleButton><ToggleButton value={7}>Неделя</ToggleButton><ToggleButton value={30}>Месяц</ToggleButton><ToggleButton value={365}>Год</ToggleButton>
          </ToggleButtonGroup>
          <DataView mobile={mobile} rows={players} empty="Пока никого" onRow={(p) => byPlayer(p.uid)}
            title={(p) => <Who username={p.username} name={p.name} id={p.uid} />}
            cols={[
              { h: 'Игрок', v: (p) => <span><Who username={p.username} name={p.name} id={p.uid} /><small style={{ color: '#5b6b8c' }}>tg {p.tg}</small></span>, card: false },
              { h: 'Боёв', v: (p) => `${p.n} (на деньги ${p.money_n})` },
              { h: 'Дуэли / боты / 2×2', v: (p) => `${p.duel} / ${p.bots} / ${p.team}` },
              { h: 'Побед', v: (p) => p.wins },
              { h: 'Поставил', v: (p) => fmt(p.staked) },
              { h: 'Получил', v: (p) => fmt(p.got) },
              { h: 'Итог игрока', v: (p) => <b style={{ color: p.net > 0 ? '#7be495' : p.net < 0 ? '#ff6b6b' : undefined }}>{p.net > 0 ? '+' : ''}{fmt(p.net)}</b> },
              { h: 'Последний бой', v: (p) => when(p.last_at) },
              { h: 'Telegram id', v: (p) => p.tg, card: true },
            ]} />
          <Typography variant="caption" sx={{ color: '#8fa1c4' }}>Тап по игроку — его бои и журнал. Игрокам суммы проигрыша не показываем — только здесь.</Typography>
        </Box>
      )}

      {tab === 4 && (
        <DataView mobile={mobile} rows={calls} empty="Вызовов пока нет"
          title={(c) => `Вызов №${c.id} · ${c.kind === 'duel' ? '1 на 1' : '2 на 2'} · ${Number(c.stake) ? `${fmt(c.stake)} SPERM` : 'на интерес'}`}
          cols={[
            { h: '№', v: (c) => c.id, card: false },
            { h: 'Создан', v: (c) => when(c.created_at) },
            { h: 'Автор', v: (c) => <Who username={c.username} name={c.name} id={c.user_id} onClick={() => byPlayer(c.user_id)} /> },
            { h: 'Формат', v: (c) => (c.kind === 'duel' ? '1 на 1' : '2 на 2'), card: false },
            { h: 'Ставка', v: (c) => (Number(c.stake) ? fmt(c.stake) : 'интерес'), card: false },
            { h: 'Бой на', v: (c) => <span>{c.asap ? 'сейчас' : when(c.at)}{c.prop_at ? <small style={{ display: 'block', color: '#ffb347' }}>предложено {when(c.prop_at)}</small> : null}</span> },
            { h: 'Приняли', v: (c) => (c.taker_usernames || c.taker_names || []).map((n) => (n && !String(n).startsWith('id ') ? `@${n}` : n)).join(', ') || '—' },
            { h: 'Статус', v: (c) => CALL_STATUS[c.status] || c.status },
            { h: 'Пуш получили', v: (c) => (c.pushed_to ?? '—') },
            { h: 'Бой', v: (c) => c.table_id ?? '—' },
            { h: 'Закрыт', v: (c) => when(c.closed_at) },
          ]} />
      )}

      {tab === 5 && (
        <Box>
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap', mb: 1 }}>
            <TextField size="small" label="Имя или @ник" value={evq.q} onChange={(e) => setEvq({ ...evq, q: e.target.value })} sx={{ width: 170 }} />
            <TextField size="small" label="id игрока" value={uid} onChange={(e) => setUid(e.target.value.replace(/\D/g, ''))} sx={{ width: 110 }} />
            <TextField size="small" select SelectProps={{ native: true }} label="Действие" value={evq.ev} onChange={(e) => setEvq({ ...evq, ev: e.target.value })} sx={{ width: 210 }}>
              <option value="">все</option>
              {Object.entries(EV).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
            </TextField>
            {(uid || evq.q || evq.ev) && <Button size="small" onClick={() => { setUid(''); setEvq({ q: '', ev: '' }); }}>Сбросить</Button>}
          </Box>
          <DataView mobile={mobile} rows={events} empty="Событий нет (журнал ведётся с 19.10)"
            title={(e) => <span>{EV[e.ev] || e.ev} <small style={{ color: '#7f8db0', fontWeight: 400 }}>{whenS(e.at)}</small></span>}
            cols={[
              { h: 'Когда (МСК)', v: (e) => <span style={{ whiteSpace: 'nowrap' }}>{whenS(e.at)}</span>, card: false },
              { h: 'Кто', v: (e) => (e.user_id ? <Who username={e.username} name={e.name} id={e.user_id} onClick={() => setUid(String(e.user_id))} /> : 'сервер') },
              { h: 'Что', v: (e) => EV[e.ev] || e.ev, card: false },
              { h: 'Бой', v: (e) => e.match_id ?? '—' },
              { h: 'Вызов', v: (e) => e.call_id ?? '—' },
              { h: 'Подробно', v: (e) => <span style={{ color: '#a9b6d0' }}>{evData(e) || '—'}</span> },
            ]} />
        </Box>
      )}

      {tab === 6 && (
        <Card sx={{ bgcolor: '#0e1424', border: '1px solid rgba(255,255,255,0.06)' }}>
          <CardContent>
            <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 700 }}>Ручки умной кассы</Typography>
            <Typography variant="caption" sx={{ color: '#8fa1c4', display: 'block', mb: 2 }}>
              Выплата за победу фиксирована, касса двигает только меткость ботов. Крутить малыми шагами. Действует со следующего боя.
            </Typography>
            <Grid container spacing={2}>
              {FIELDS.map(([k, label, hint]) => (
                <Grid item xs={12} sm={6} md={4} key={k}>
                  <TextField fullWidth size="small" type="number" label={label} helperText={hint} value={form[k] ?? ''}
                    inputProps={{ step: 'any', min: data?.limits?.[k]?.[0], max: data?.limits?.[k]?.[1] }}
                    onChange={(e) => setForm({ ...form, [k]: e.target.value })} />
                </Grid>
              ))}
            </Grid>
            <Button variant="contained" startIcon={<Save />} sx={{ mt: 2 }} onClick={save}>Сохранить</Button>
          </CardContent>
        </Card>
      )}

      <Dialog open={!!chat} onClose={() => setChat(null)} fullWidth maxWidth="sm">
        <DialogTitle>Чат боя №{chat?.match?.id} · {chat ? MODE[chat.match.mode] : ''}</DialogTitle>
        <DialogContent>
          {chat?.rows.map((c, i) => (
            <Box key={i} sx={{ mb: 1, pl: 1, borderLeft: `3px solid ${c.team === 0 ? '#ff4a3d' : '#3b8bff'}` }}>
              <Typography variant="caption" sx={{ color: '#8fa1c4' }}>{when(c.at)} · {c.is_bot ? '🤖 ' : ''}{c.name}{c.model ? ` · ${c.model}` : ''}</Typography>
              <Typography variant="body2">{c.text || (c.sticker ? `[стикер: ${c.sticker}]` : '')}</Typography>
            </Box>
          ))}
          {chat && !!chat.models.length && (
            <Typography variant="caption" sx={{ display: 'block', mt: 2, color: '#8fa1c4' }}>
              Реплики ботов за 7 дней по моделям: {chat.models.map((x) => `${x.model} — ${x.n}`).join(', ')}
            </Typography>
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
}
